var options={add:false,addTo:'panels',noResults:'No results found.',placeholder:'Search',searchIn:'panels',splash:'',title:'Search'};export default options;